import React from 'react'
import { Link } from 'react-router-dom'

export default function FooterTop({bg}:{bg:any}) {
    return (
        <section className={`py-16 ${bg} overflow-hidden relative`}>
            <div className="container mx-auto px-4 relative z-10">
                <div className="bg-primary-dark/40 backdrop-blur-xl border border-white/10 rounded-[3rem] p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-12 shadow-2xl relative overflow-hidden group">
                    {/* Decorative pulse background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                    
                    <div className="relative z-10 text-center md:text-left">
                        <h3 className="text-3xl md:text-4xl font-black text-white mb-4 uppercase tracking-tight">
                            Want to Become a <span className="text-accent">Real Estate Expert?</span>
                        </h3>
                        <p className="text-white/40 text-xs md:text-sm font-bold uppercase tracking-[0.2em]">
                            We'll help you to grow your career and achieve excellence.
                        </p>
                    </div>
                    
                    <Link to="#" className="relative z-10 group/btn">
                        <div className="absolute inset-0 bg-accent rounded-full blur-xl opacity-20 group-hover/btn:opacity-50 transition-all scale-110"></div>
                        <span className="relative inline-block bg-accent hover:bg-white text-primary-dark font-black py-5 px-12 rounded-full text-sm uppercase tracking-[0.2em] transition-all duration-500 shadow-xl hover:shadow-accent/40 active:scale-95 group-hover/btn:translate-x-2">
                            SignUp Today <i className="fa-solid fa-arrow-right-long ml-3 transition-transform group-hover/btn:translate-x-1"></i>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    )
}
